(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["index-rep-01-test-your-tattoo"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initFadeCarousels(root) {
    var scope = root || document;
    var carousels = scope.querySelectorAll('[data-hero-bg-carousel], [data-hero-fade-carousel]');
    carousels.forEach(function (el) {
      if (el.dataset.carouselReady === '1') return;
      var slides = el.querySelectorAll('.hero-fade-slide');
      if (slides.length < 2) return;
      el.dataset.carouselReady = '1';
      var i = 0;
      var ms = parseInt(el.getAttribute('data-interval'), 10) || 4000;
      if (ms < 1000) ms = 1000;
      setInterval(function () {
        slides[i].classList.remove('is-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
      }, ms);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initFadeCarousels(document);
    });
  } else {
    initFadeCarousels(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event && event.target) initFadeCarousels(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-rep-04-before-after"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setPos(frame, pct) {
    var p = Math.max(0, Math.min(100, pct));
    frame.style.setProperty('--ba-pos', p + '%');
    var range = frame.querySelector('[data-ba-range]');
    if (range && String(range.value) !== String(Math.round(p))) range.value = String(Math.round(p));
  }

  function measure(frame) {
    frame.style.setProperty('--ba-frame-w', frame.offsetWidth + 'px');
  }

  function initFrame(frame) {
    if (!frame || frame.dataset.baReady === '1') return;
    frame.dataset.baReady = '1';
    measure(frame);

    var range = frame.querySelector('[data-ba-range]');
    if (range) {
      setPos(frame, parseFloat(range.value) || 50);
      range.addEventListener('input', function () {
        setPos(frame, parseFloat(range.value) || 0);
      });
    }

    /* The native range control handles clicks, drags, touch and keyboard input.
       Avoid document-level pointer capture so normal page scrolling is never trapped. */

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(function () { measure(frame); });
      ro.observe(frame);
    } else {
      window.addEventListener('resize', function () { measure(frame); });
    }
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-ba-slider]').forEach(initFrame);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event && event.target) {
      event.target.querySelectorAll('[data-ba-slider]').forEach(function (el) {
        el.dataset.baReady = '';
      });
      initAll(event.target);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
